import Organisations from "./organisations"

export default Organisations
